'use client';

import { c as _c } from "react/compiler-runtime";
import { SCREEN_ADDRESS_ROUTE } from '@repo/address-screening/client';
import { Web3Provider as RepoWeb3Provider } from '@repo/web3';
import { memo, useState } from 'react';
import { withDeploymentParam } from '@/config/deployment';
import { isEmbedded, isSafeAppEnvironment } from '@/helpers/iframe';
import { isAnalyticsOptedOut } from '@/lib/analytics/client/consent';
import { getQueryClient } from '@/services/react-query';
import { APP_METADATA, getVaultsWagmiAdapter } from './config/wagmi.client';
import Web3ContextProvider, { type Web3ContextProviderProps } from './Web3.context';
export interface Web3ProviderProps extends Web3ContextProviderProps {
  cookies: string | null;
}

// Endpoint carries the `?dpl=` pin (@repo/web3 has no header seam); computed once so
// connect-time and tx-time (`TransactionV2.context`) screening share the same react-query key.
const SCREEN_ADDRESS_ENDPOINT = withDeploymentParam(SCREEN_ADDRESS_ROUTE);
const Web3Provider = t0 => {
  const $ = _c(10);
  const {
    cookies,
    onSetTargetChainEvent,
    children
  } = t0;
  const [t1] = useState(_temp);
  const {
    wagmiConfig,
    wagmiAdapter
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = isAnalyticsOptedOut();
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const analyticsEnabled = !t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = getQueryClient();
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== children || $[3] !== onSetTargetChainEvent) {
    t4 = <Web3ContextProvider onSetTargetChainEvent={onSetTargetChainEvent}>{children}</Web3ContextProvider>;
    $[2] = children;
    $[3] = onSetTargetChainEvent;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== cookies || $[6] !== t4 || $[7] !== wagmiAdapter || $[8] !== wagmiConfig) {
    t5 = <RepoWeb3Provider wagmiAdapter={wagmiAdapter} wagmiConfig={wagmiConfig} cookies={cookies} metadata={APP_METADATA} screenAddressEndpoint={SCREEN_ADDRESS_ENDPOINT} ssr={true} themeMode="system" queryClient={t3} enableAppKitAnalytics={analyticsEnabled}>{t4}</RepoWeb3Provider>;
    $[5] = cookies;
    $[6] = t4;
    $[7] = wagmiAdapter;
    $[8] = wagmiConfig;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default memo(Web3Provider);
function _temp() {
  return getVaultsWagmiAdapter(isEmbedded() && isSafeAppEnvironment());
}